/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/CardView',['require',
        'lodash',
        'pixi',
        'absolute',
        'absolute/coords',
        'Arkadium/GameEngine/Core/EngineManagers',
        'Arkadium/GameEngine/Tween/Tween',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'CardUI/CardHint'
    ],
    function (require, _, PIXI, Absolute, Coords, EngineManagers, Tween, SpriteNode, CardHint) {


        var CardView = function (card, supplyView) {
            this.initCardView(card, supplyView);
        };


        CardView.constuctor = CardView;
        CardView.prototype = Object.create(SpriteNode.prototype);

        CardView.TopLayer = 5;
        CardView.BaseLayer = 0;

        CardView.ScaleFactor = 156 / 384;
        CardView.HintScale = 2.52;

        CardView.RotationAngle = Math.PI;

        CardView._cardPickUp = new PIXI.Point(-4, -8);
        CardView._shadowUp = new PIXI.Point(35, 35);
        CardView._shadowUpScale = 1.25;
        CardView._shadowDownScale = 1.2;
        CardView._shadowDownFront = new PIXI.Point(7, 13);
        CardView._shadowDownBack = new PIXI.Point(4, 7);
        CardView.MSecPerGesture = 300;
        CardView.GestureRecognitionDelta = 30;

        CardView.FullWidth = 382;
        CardView.FullHeight = 510;


        var CardBelowCache = function () {
            this.initCardBelowCache();
        };

        CardBelowCache.prototype.initCardBelowCache = function () {
            this.Card = null;
            this.Pile = null;
        };

        CardView.prototype.getShadowPosition = function () {
            var offset = (this.IsPickedUp ? CardView._shadowUp :
                    (this.CardFront.visible ? CardView._shadowDownFront : CardView._shadowDownBack)
            ).clone();
            this.shadow.scale.set(this.IsPickedUp ? CardView._shadowUpScale : CardView._shadowDownScale);
            return new PIXI.Point(Coords.x(offset.x), Coords.y(offset.y) - this.shadowHeight / 2);
        };

        CardView.prototype.initCardView = function (card, supplyView) {
            SpriteNode.call(this);
            this.Card = card;
            this.SupplyView = supplyView;

            this.IsPickedUp = false;
            this.IsDraggable = true;

            this._dragId = -1;

            this.OnMouseDownEventHandler = this.OnMouseDownEvent.bind(this);
            this.PointDown.add(this.OnMouseDownEventHandler);
            //this.mousedown = this.OnMouseDownEventHandler;


            this.OnCardMouseUpEventHandler = this.OnCardMouseUpEvent.bind(this);
            this.PointUp.add(this.OnCardMouseUpEventHandler);
            this.OnMouseMoveEventHandler = this.OnMouseMoveEvent.bind(this);
            supplyView.Scene.Root.PointMove.add(this.OnMouseMoveEventHandler);
            this.OnMouseUpEventHandler = this.OnMouseUpEvent.bind(this);
            supplyView.Scene.Root.PointUp.add(this.OnMouseUpEventHandler);

            this.interactive = true;
            this.buttonMode = true;


            this.LockMouseUpReveal = false;
            this.IsRevealToShow = false;
            this._swipeUpRecognized = false;
            this.PostionChanged = false;
            this.CardBelowCache = new CardBelowCache();

            this.CardFront = null;
            this.CardBack = null;
            this._highlightTexture = null;
            this._keyboardHighlightTexture = null;
            this.shadow = null;
            this._hintTexture = null;
            this._goalTexture = null;
            this._isRighPressed = false;
            this._holdTapValue = false;

            this.LayerWhileAnimating = null;

            this._isDragging = false;
            this._isHinted = false;
            this._isGoalGlow = false;
            this._keyboardHighlighted = false;
            this._animating = false;
            this._cardFlipAngle = 1;


            this._localTouch = new PIXI.Point();
            this._cardStartDragPos = new PIXI.Point();

            this._isTweenPickUp = false;

            this._scaleForCardSprites = CardView.ScaleFactor;

            this.HasInitRun = false;

            this._selectOnMove = false;
            this._firstDrag = true;
            this._oldPosition = new PIXI.Point();
            this._newPosition = new PIXI.Point();

            this.AlreadyExcluded = false;

            this.IsTweeningPickUp = false;

            this._shadowScaleClean = false;

            this._fakeRotationY = 0;

            this._highlighted = false;

            this._cardBelow = new CardBelowCache();

            this.Init(null);

            this.hitArea = new PIXI.Rectangle(-this._cachedWidth / 2, -this._cachedHeight / 2, this._cachedWidth, this._cachedHeight);

            this.buttonMode = true;
            this.HasJustBeenMoved = false;
            this.InputIsBlocked = false;
            this._mouseDownPos = null;
            this._mouseWasUpon = false;

            this.checkStartAnimationCoords = {
                Klondike: function (y) {
                    return y > Coords.y(220.2)
                }.bind(this),
                Spider: function (y) {
                    return y < Coords.y(961)
                }.bind(this),
                Pyramid: function (y) {
                    return y < Coords.y(900)
                }.bind(this),
                FreeCell: function (y) {
                    return y < Coords.y(961)
                }.bind(this),
                TriPeaks: function (y) {
                    return y < Coords.y(900)
                }.bind(this)
            };
        };


        Object.defineProperty(CardView.prototype, "IsDragging", {
            get: function () {
                return this._isDragging;
            },
            set: function (value) {
                if (this.parent.Pile.Cards.length > 1) this.SupplyView.forceShadowHide(value, this.parent.Pile.Cards, this.Card);
                if (this._isDragging != value) {
                    this._isDragging = value;

                    if (this.parent != null) {
                        this.SetIsPickedUpForCardsAbove(this._isDragging);
                    }
                }
            }
        });

        Object.defineProperty(CardView.prototype, "IsHinted", {
            get: function () {
                return this._isHinted;
            },
            set: function (value) {
                if (this._isHinted != value) {
                    this._isHinted = value;
                    this._hintTexture.visible = value;

                    if (this._isHinted) {
                        this._hintTexture.AnimatePulse();
                    } else {
                        this._hintTexture.StopPulse();
                    }
                }
            }
        });

        Object.defineProperty(CardView.prototype, "IsGoalGlow", {
            get: function () {
                return this._isGoalGlow;
            },
            set: function (value) {
                if (this._goalTexture == null || value == this._isGoalGlow) {
                    return;
                }
                this._isGoalGlow = value;
                // TODO check this
                setTimeout(function () {
                    this._goalTexture.visible = value;
                }.bind(this), 0);

            }
        });

        Object.defineProperty(CardView.prototype, "KeyboardHighlighted", {
            get: function () {
                return this._keyboardHighlighted;
            },
            set: function (value) {
                if (this._keyboardHighlighted === value)
                    return;
                this._keyboardHighlighted = value;
                if (value) {
                    this.addHighlightedTexture();
                } else if (this._keyboardHighlightTexture != null) {
                    this.removeHighlightedTexture();
                }
            }
        });

        CardView.prototype.addHighlightedTexture = function () {
            this._keyboardHighlightTexture = PIXI.Sprite.fromFrame(this.SupplyView.GetThemeAssetPath("keyboard_highlight"));
            this._keyboardHighlightTexture.scale.set(1.22);
            this._keyboardHighlightTexture.anchor.x = this._keyboardHighlightTexture.anchor.y = 0.5;
            this._keyboardHighlightTexture.x += 1;
            this._keyboardHighlightTexture.y += 1;
            this._keyboardHighlightTexture.InputEnabled = false;
            if (this.Card.Pile.Name === 'Waste' || this.Card.Pile.Name.indexOf('Tableau') !== -1 ||
                this.Card.Pile.Name.indexOf('Foundation') !== -1 || this.Card.Pile.Name.indexOf('Free') !== -1 ||
                (this.isGame('Pyramid') && this.Card.Pile.Name === 'Stock')) {
                this.CardFront.addChild(this._keyboardHighlightTexture);
                this.CardFront.setChildIndex(this._keyboardHighlightTexture, 0);
            } else if (this.Card.Pile.Name === 'Stock') {
                this.CardBack.addChild(this._keyboardHighlightTexture);
                this.CardBack.setChildIndex(this._keyboardHighlightTexture, 0);
            }
        };

        CardView.prototype.removeHighlightedTexture = function () {
            if (this.CardFront.children.indexOf(this._keyboardHighlightTexture) != -1) {
                this.CardFront.removeChild(this._keyboardHighlightTexture);
            } else if (this.CardBack.children.indexOf(this._keyboardHighlightTexture) != -1) {
                this.CardBack.removeChild(this._keyboardHighlightTexture);
            }
            this._keyboardHighlightTexture = null;
        }


        Object.defineProperty(CardView.prototype, "Animating", {
            get: function () {
                return this._animating;
            },
            set: function (value) {
                if (this._animating == value) {
                    return;
                }
                if (value) {
                    if (this.shadow != null) {
                        this.shadow.alpha = 0;
                    }
                    if (this._highlightTexture != null) {
                        this._highlightTexture.alpha = 0;
                    }
                    if (this._keyboardHighlightTexture != null) {
                        this._keyboardHighlightTexture.alpha = 0;
                    }
                    if (this.CardBack != null) {
                    }
                    this._shadowScaleClean = false;
                }
                this._animating = value;
            }
        });

        Object.defineProperty(CardView.prototype, "CardFlipAngle", {
            get: function () {
                return this._cardFlipAngle;
            },
            set: function (value) {
                if (Math.abs(value - this._cardFlipAngle) < 0.000001) {
                    return;
                }
                this._cardFlipAngle = value;
                this.OnCardFlipAngleChanged();
            }
        });

        CardView.prototype.OnCardFlipAngleChanged = function () {
            this.UpdateCardFlip();
            this.ApplyCardFlipRotation(this.CardFlipAngle * CardView.RotationAngle);
        };

        CardView.prototype.forceShadowHide = function (state) {
            this._forceShadowHide = state;
        };

        CardView.prototype.Init = function (callback) {
            if (!this.HasRunInit) {
                this.HasRunInit = true;
                if (this.SupplyView.EnableHighlight) {
                    this._highlightTexture = new SpriteNode(this.SupplyView.GetThemeAssetPath("highlight"));
                    this._highlightTexture.scale.x = this._highlightTexture.scale.y = 2.46 * CardView.ScaleFactor;
                    this._highlightTexture.InputEnabled = false;
                    this.addChild(this._highlightTexture);
                }
                if (this.SupplyView.CardSupply.Authority.IsChallenge) {
                    this._goalTexture = new SpriteNode(this.SupplyView.GetThemeAssetPath("goal_glow"));
                    this._goalTexture.scale.x = this._goalTexture.scale.y = 2.44 * CardView.ScaleFactor;
                    if (Absolute.Platform.isMobile()) {
                        this._goalTexture.scale.y = CardView.ScaleFactor * 2.9;
                    }
                    this._goalTexture.InputEnabled = false;
                    this._goalTexture.visible = false;
                    this.addChild(this._goalTexture);
                }


                this._hintTexture = new CardHint(this.SupplyView.GetThemeAssetPath(CardHint.TexturePath));
                this.addChild(this._hintTexture);

                this.CardFrontPathBase = this.SupplyView.GetThemeAssetPath(this.Card.GetThemeItem());
                this.CardBackPathBase = this.SupplyView.GetThemeAssetPath("cardback");

                this.CardFront = new SpriteNode();
                if (this.SupplyView.EnableCardBacks)
                    this.CardBack = new SpriteNode();

                this.SetCardTextures();
                if (this.CardBack != null) {
                    this.addChild(this.CardBack);
                }

                if (this.SupplyView.EnableShadows) {
                    this.shadow = new SpriteNode(this.SupplyView.GetThemeAssetPath("shadow"));
                    this.shadow.InputEnabled = false;
                    this.shadow.visible = true;
                    this.shadow.alpha = 0.55;
                    this.shadow.sprite.anchor.x = 0.5;
                    this.shadow.scale.set(CardView._shadowDownScale);
                    this.shadow.sprite.anchor.y = 0;
                    this.CardFront.addChild(this.shadow);
                    this.CardFront.setChildIndex(this.shadow, 0);
                    this.shadowHeight = this.shadow.height;
                }

                this.addChild(this.CardFront);

                this.UpdateCardFlip();

                SpriteNode.prototype.Init.call(this, callback);
            }
        };

        CardView.prototype.SetCardTextures = function () {
            var parentScale = 1;
            if (this.SupplyView.parent != null) {
                parentScale = this.SupplyView.parent.scale.x;
            }

            var currentWidth = parentScale * CardView.ScaleFactor * Coords.x(CardView.FullWidth),
                currentHeight = parentScale * CardView.ScaleFactor * Coords.x(CardView.FullHeight);

            if (Math.abs(currentWidth - this._cachedWidth) < 0.0000001) {
                return;
            }

            this.CardFrontPath = this.CardFrontPathBase;
            this.CardBackPath = this.CardBackPathBase;

            this.CardFront.SetTexture(this.CardFrontPath);

            if (this.SupplyView.EnableCardBacks) {
                this.CardBack.SetTexture(this.CardBackPath);
            }

            this._scaleForCardSprites = CardView.ScaleFactor * 2;
            this._cachedWidth = currentWidth;
            this._cachedHeight = currentHeight;
        };

        CardView.prototype.UnregisterEvents = function () {
            this.mousedown = null;
            this.mouseup = null;
            this.SupplyView.Scene.Root.PointMove.remove(this.OnMouseMoveEventHandler);
            this.OnMouseUpEventHandler = this.OnMouseUpEvent.bind(this);
            this.SupplyView.Scene.Root.PointUp.remove(this.OnMouseUpEventHandler);

            this.PointDown = null;
            this.PointUp = null;
            this._cardBelow.Card = null;
            this._cardBelow.Pile = null;
        };

        CardView.prototype.IsFaceUp = function () {
            return this.CardFlipAngle < 0.5;
        };

        CardView.prototype.OnMouseDownEvent = function (sender, pointEvent) {
            if (this.InputIsBlocked) return;
            this._mouseWasUpon = true;
            this._mouseDownPos = new PIXI.Point(pointEvent.originalEvent.x, pointEvent.originalEvent.y);
            
            if (this.SupplyView.IsCardDragging) {
                return;
            }

            this._holdTapValue = Date.now();

            this.SupplyView.ClearRevealCardStates(this);
            this.SupplyView.GameInputInterpreter.IsClickedOnCard = true;

            if (!this.LockMouseUpReveal && !this.IsDraggable) {
                if (this.IsFaceUp() && this.Card.Pile.IsPileAllowToRevealCard()) {
                    this.IsRevealToShow = !this.IsRevealToShow;
                }
            }

            if (this.SupplyView.KeyboardFocus != null) {
                this.SupplyView.KeyboardFocus.Keyboard.LoseKeyboardFocus();
            }

            this._shadowScaleClean = false;


            this.UpdateInteractionMode();

            if (this.IsDraggable) {
                EngineManagers.Sounds.PlaySound("pickupCard");
                var highlightedCard = this.SupplyView.GameInputInterpreter.GetHighlightedCard();
                if (highlightedCard == null || highlightedCard == this) {
                    this.StartDrag(pointEvent);
                } else {
                    this._selectOnMove = true;
                }
            } else {
                this.SupplyView.TellMouseDown(this);
            }
        };

        CardView.prototype.OnMouseMoveEvent = function (sender, pointEvent) {
            if (this.InputIsBlocked) return;
            if (this.IsDraggable && this._selectOnMove) {
                this._selectOnMove = false;
                this.StartDrag(pointEvent);
            }

            if (this._mouseWasUpon) {
                var mouseMovePos = new PIXI.Point(pointEvent.originalEvent.x, pointEvent.originalEvent.y);

                this.HasJustBeenMoved = (Math.abs(mouseMovePos.x - this._mouseDownPos.x) > 10) ||
                    (Math.abs(mouseMovePos.y - this._mouseDownPos.y) > 10);
                if (this.HasJustBeenMoved) this._mouseWasUpon = false;
            }

            if (this.IsDragging) {
                if (this.IsSwipedUp(pointEvent))
                    this._swipeUpRecognized = true;
                if (this._firstDrag) {
                    this.SupplyView.OnMoveCards();
                    this._firstDrag = false;
                }
                this.ClearPreviousSelection(
                    pointEvent.global.x - this._localTouch.x, pointEvent.global.y - this._localTouch.y
                );
                this.Position = this.parent.toLocal({
                    x: this._cardStartDragPos.x + pointEvent.global.x - this._localTouch.x,
                    y: this._cardStartDragPos.y + pointEvent.global.y - this._localTouch.y
                });

                if (Math.abs(this.Position.x) > 0) {
                    this.IsRevealToShow = false;
                    this.LockMouseUpReveal = true;
                }
            }
        };

        CardView.prototype.ClearPreviousSelection = function (x, y) {
            var minDragDistance = 10;
            var dragLength = Math.sqrt(x * x + y * y);
            var highlightedCard = this.SupplyView.GameInputInterpreter.GetHighlightedCard();
            if (highlightedCard != null && highlightedCard !== this && dragLength > minDragDistance)
                this.SupplyView.GameInputInterpreter.ClearHighlight();
        };

        CardView.prototype.OnMouseUpEvent = function (sender, pointEvent) {			
            if (this.InputIsBlocked) return;
            if (this.IsDraggable && this._selectOnMove) {
                this._selectOnMove = false;
                this.StartDrag(pointEvent);
            }
            if (this._mouseWasUpon) {
                var mouseUpPos = new PIXI.Point(pointEvent.originalEvent.x, pointEvent.originalEvent.y);
                this.HasJustBeenMoved = (Math.abs(mouseUpPos.x - this._mouseDownPos.x) > 10) ||
                    (Math.abs(mouseUpPos.y - this._mouseDownPos.y) > 10);
                this._mouseWasUpon = false;
            }
            this._shadowScaleClean = false;
            this.LockMouseUpReveal = false;
            if (this.IsDragging) {
                if (this._swipeUpRecognized && (Date.now()) - this._holdTapValue < MSecPerGesture)
                    this.SupplyView.GameInputInterpreter.ClickCard(this);

                this.SupplyView.TellMouseDown(this);

                if (!this.Animating) {
                    this.SupplyView.TellMouseUp(this);
                }


                this.IsDragging = false;
                this._swipeUpRecognized = false;
                this.SupplyView.IsCardDragging = false;

            }
            this.SupplyView.GameInputInterpreter.IsClickedOnCard = false;
        };

        CardView.prototype.OnCardMouseUpEvent = function (sender, pointEvent) {
        };

        CardView.prototype.StartDrag = function (pointEvent) {
            var screenPos = this.toGlobal(this.position); // TODO this.parent?
            var globalScale = this.scale.x * this.parent.scale.x;

            var cardShiftInPile = this.GetCardPositionInPile(this.parent, true);
            cardShiftInPile.x *= globalScale;
            cardShiftInPile.y *= globalScale;
            this._cardStartDragPos = new PIXI.Point(
                screenPos.x - cardShiftInPile.x * this.SupplyView.scale.x,
                screenPos.y - cardShiftInPile.y * this.SupplyView.scale.y
            );
            this._localTouch.x = pointEvent.global.x;
            this._localTouch.y = pointEvent.global.y;

            this.IsDragging = true;
            this.SupplyView.IsCardDragging = true;
            this._firstDrag = true;

            this.parent.parent.addChild(this.parent); // force to top
        };

        CardView.prototype.IsSwipedUp = function (point) {
            return false;
        };

        CardView.prototype.ForceDrop = function (pile) {
            if (this.IsDragging) {
                this.SupplyView.TellMouseUp(this, pile);
                this.IsDragging = false;
                this.SupplyView.IsCardDragging = false;
                this._dragId = -1;
                this.SupplyView.GameInputInterpreter.IsClickedOnCard = false;
            }
        };

        CardView.prototype.UpdatePosition = function () {
            var position = this.GetCardPositionInPile(this.parent);
            if (Math.abs(this.position.x - position.x) < 0.000001 && Math.abs(this.position.y - position.y) < 0.000001) {
                this._positionChanged = false;
                return;
            }

            this._positionChanged = true;

            this._shadowScaleClean = false;
            this.position.x = position.x;
            this.position.y = position.y;
        };

        CardView.prototype.UpdateInternal = function (time, pileHeightHalf) {
            var pileParent = null;
            var pileView = this.parent;
            if (pileView != null) {
                pileParent = pileView;
            }
            this.UpdateTextureProperties(pileHeightHalf);
            if (!this.Animating) {
                if (pileParent != null) {
                    this.UpdateInteractionMode();

                    if (!this.IsDragging) {
                        this.UpdatePosition();
                    } else {
                        this._positionChanged = Math.abs(this._oldPosition - this._newPosition) < 0.000001;
                        this._oldPosition = this._newPosition;
                    }

                    this.SetCardFacing(pileParent.CardFacing);
                }

                if (this.IsPickedUp) {
                    this._shadowScaleClean = false;
                }
            }

            this.UpdateScale();

            if (this.LayerWhileAnimating != null) {
                this.Layer = this.LayerWhileAnimating;
            } else if (this.IsPickedUp || this.IsInAnimatingStack()) {
                this.SetLayerForCardsAbove(CardView.TopLayer);
            } else {
                this.Layer = this.BaseLayer;
            }

            this._shadowScaleClean = false;

            SpriteNode.prototype.UpdateInternal.call(this, time);
        };

        CardView.prototype.UpdateCardFlip = function () {
            if (this.CardFlipAngle < 0.5) {
                if (this.CardBack != null) {
                    this.CardBack.visible = false;
                    this.setInactive(this.CardBack);
                }
                this.CardFront.visible = true;
                this.setActive(this.CardFront, CardView._shadowDownFront);
            } else {
                this.CardFront.visible = false;
                this.setInactive(this.CardFront);
                if (this.CardBack != null)
                    this.CardBack.visible = true;
                this.setActive(this.CardBack, CardView._shadowDownBack);
            }
        };

        CardView.prototype.setActive = function (target, shadowPos) {
            this.shadow.position.set(shadowPos.x, shadowPos.y);
            target.addChild(this.shadow);
            if (this._highlightTexture) {
                target.addChild(this._highlightTexture);
                target.setChildIndex(this._highlightTexture, 0);
            }
            if (this._goalTexture) {
                target.addChild(this._goalTexture);
                target.setChildIndex(this._goalTexture, 0);
            }
            target.setChildIndex(this.shadow, 0);
        };

        CardView.prototype.setInactive = function (target) {
            if (target.children.indexOf(this.shadow) !== -1) {
                target.removeChild(this.shadow);
            }
            if (target.children.indexOf(this._highlightTexture) !== -1) {
                target.removeChild(this._highlightTexture);
            }
            if (target.children.indexOf(this._goalTexture) !== -1) {
                target.removeChild(this._goalTexture);
            }
        };

        CardView.prototype.UpdateScale = function () {

            this.scale.x = this.scale.y = this.SupplyView.CardScale;

            var rotscale = Math.cos(this._fakeRotationY);
            if (rotscale < 0) {
                rotscale = -rotscale;
                this.rotation = Math.PI;
            } else {
                this.rotation = 0;
            }

            if (this.CardFront != null) {
                this.CardFront.scale.x = rotscale * this._scaleForCardSprites;
                this.CardFront.scale.y = this._scaleForCardSprites;
            }

            if (this.CardBack != null) {
                this.CardBack.scale.x = rotscale * this._scaleForCardSprites;
                this.CardBack.scale.y = this._scaleForCardSprites;
            }

        };

        Object.defineProperty(CardView.prototype, "HighliteTextureVisibility", {
            set: function (value) {
                if (this._highlightTexture != null && this._highlightTexture.visible != value) {
                    this._highlightTexture.visible = value;
                }
            }
        });

        CardView.prototype.UpdateTextureProperties = function (pileHeightHalf) {
            this.checkAndSetShadowVisibility();
            if (this._highlightTexture != null && Math.abs(this._highlightTexture.alpha) < 0.1) {
                this._highlightTexture.alpha = 1;
            }

            if (this.shadow != null) {
                var pileView = this.parent;
                if (pileView != null && pileView.PileMode == 0/*PileView.Layout.Pile*/ && pileView.Pile.Bottom != this.Card) {
                    this.shadow.alpha = 0;
                } else if (Math.abs(this.shadow.alpha) < 0.1) {
                    this.shadow.alpha = 0.55;
                }
            }

            this.KeyboardHighlighted = this.parent.Keyboard && this.parent.Keyboard.HasKeyboardFocus && this.parent.FocusedCard == this;

            this.HighliteTextureVisibility = (this.IsPickedUp || this.SupplyView.GameInputInterpreter.GetHighlightedCard() == this || this.IsInHighlightedStack());

            var shadowPosition = this.getShadowPosition();
            if (this.shadow != null) {
                var animationTime = 0.15;
                if (this.IsDragging) {
                    this.shadow.alpha = 1;
                    this.shadow.visible = true;
                    if (!((Math.abs(this.shadow.position.x - shadowPosition.x) < 0.1)
                        && (Math.abs(this.shadow.position.y - shadowPosition.y) < 0.1)) && !this.IsTweeningPickUp) {
                        Tween.Start(this.shadow).MoveTo(shadowPosition, animationTime, TWEEN.Easing.Cubic.Out);
                    }
                } else {
                    Tween.Start(this.shadow).MoveTo(shadowPosition, animationTime, TWEEN.Easing.Cubic.Out);
                    this.shadow.alpha = 0.55;
                }
            }

            if (this.SupplyView.CardSupply.CardAnimator.IsShuffleAnimationRunning()) {
                this.shadow.x = shadowPosition.x;
                this.shadow.y = shadowPosition.y;
            }

            this.shadow.visible = this.checkWithStock(pileHeightHalf) && (this.Card.Pile.Name.indexOf('Tableau') !== -1
                || this.Card.Pile.Name.indexOf('FaceDown') !== -1);

            this.checkAndSetShadowVisibility();
            this.shadow.visible = this.Card.Pile.Name.indexOf('Tableau') !== -1 && this._forceShadowHide
                ? !this._forceShadowHide : this.shadow.visible;
            this.checkForMultipleDragging();
        };

        CardView.prototype.checkWithStock = function (pileHeightHalf) {
            var stockPile = this.SupplyView.GetPileView('Stock');
            if (this.Card.Supply.GameName === 'FreeCell') {
                var pile = this.SupplyView.GetPileView('Tableau3');
                var lastCard = pile.Pile.GetCardAtPos(pile.Pile.Cards.length - 1);
                return this.Card === lastCard || this.CardFront.visible;
            }
            return this.worldTransform.ty >= stockPile.worldTransform.ty + pileHeightHalf ||
                this.worldTransform.ty <= stockPile.worldTransform.ty - pileHeightHalf;
        };

        CardView.prototype.checkAndSetShadowVisibility = function () {
            var pileName = this.Card.Pile.Name;
            if (pileName === 'Stock' && !this.GetCardBelow()) this.shadow.Visible = true;
            if (pileName === 'Stock' && this.isGame('Pyramid') && this.GetCardBelow()) {
                this.shadow.Visible = false;
            }
            if (pileName === 'Waste') {
                if (this.isGame('Klondike')) {
                    this.shadow.visible =
                        this.parent.Pile.Cards.indexOf(this.Card) >= this.parent.Pile.Cards.length - 3;
                } else if (this.isGame('Pyramid') || this.isGame('TriPeaks')) {
                    this.shadow.visible = !this.GetCardBelow();
                }
            }
            if ((pileName.indexOf('Foundation') !== -1 || pileName.indexOf('Free') !== -1) && this.parent.Pile) {
                var cards = this.parent.Pile.Cards.slice();
                this.shadow.visible = cards.pop() === this.Card || cards.pop() === this.Card;
            }

            if (this.Card.Pile.Name === 'Stock' && !this.isGame('Pyramid') && this.GetCardBelow() === null) {
                this.shadow.Visible = true;
            }
        };

        CardView.prototype.checkForMultipleDragging = function () {
            if (this.IsDragging && this.Card.Pile.Name.indexOf('Tableau') !== -1) {
                var cardsCount = this.parent.Pile.Cards.length - this.parent.Pile.Cards.indexOf(this.Card);
                this.shadow.visible = true;
                var scale = this.GetShadowScale();
                this.shadow.scale.y = scale.y + ((cardsCount > 1) ? 0.04 : 0.08);
            }
        };

        CardView.prototype.AnimateSingleTapRejection = function () {
            if (this.wiggleAnimationStarted) return;
            this.wiggleAnimationStarted = true;
            var wiggleTime = 0.04, tween = Tween.Start(this),
                wiggleDistance = 16, wiggleReductionStep = 2, wiggleCount = 6;
            for (var i = 0; i < wiggleCount; i++) {
                wiggleDistance += (wiggleDistance > 0) ? -wiggleReductionStep : wiggleReductionStep;
                wiggleDistance *= -1;
                tween.MoveTo((new PIXI.Point(this.x - wiggleDistance, this.y)), wiggleTime, TWEEN.Easing.Linear.None);
            }
            setTimeout(function () {
                this.wiggleAnimationStarted = false;
            }.bind(this), wiggleTime * wiggleCount * 1500);
        };

        CardView.prototype.isGame = function (gameName) {
            return this.Card.Supply.GameName === gameName;
        };

        CardView.prototype.AnimatePickUp = function (moveTo, duration) {
            // TODO
        };


        CardView.prototype.GetShadowScale = function () {
            if (this.shadow == null) {
                return new PIXI.Point(1, 1);
            }


            if ((this._shadowScaleClean || !this.shadow.Visible) && !(this.shadow && this.shadow.visible)) {
                return this.shadow.Scale;
            }
            var retval = new PIXI.Point(1, 1);

            var previousScale = this.shadow.Scale;

            var pileParent = this.Parent;

            var topCard = null;
            if (pileParent != null) {
                var relevantPile = (pileParent.PileStackedOn == null ? pileParent : pileParent.PileStackedOn).children;
                for (var i = relevantPile.length - 1; i >= 0; i--) {
                    if (relevantPile[i] instanceof CardView &&
                        relevantPile[i].IsPickedUp == this.IsPickedUp &&
                        relevantPile[i].Animating == this.Animating) {
                        topCard = relevantPile[i];
                        break;
                    }
                }
                if (topCard == null && relevantPile != pileParent.children) {
                    for (var i = pileParent.children.length - 1; i >= 0; i--) {
                        if (pileParent.children[i] instanceof CardView) {
                            topCard = pileParent.children[i];
                            break;
                        }
                    }
                }
            }

            if (topCard != null) {
                if (!topCard.IsDragging)
                    topCard.UpdatePosition();

                var scaleX = topCard.CardFront.children.slice().pop().worldTransform.a,
                    scaleY = topCard.CardFront.children.slice().pop().worldTransform.d;

                var screenCardSize = new PIXI.Point(topCard._cachedWidth,
                    topCard._cachedHeight);

                var topCenterGlobal = topCard.toGlobal(new PIXI.Point(0.5 * screenCardSize.x, 0.5 * screenCardSize.y));
                var thisCenterGlobal = this.toGlobal(new PIXI.Point(-0.5 * screenCardSize.x, -0.5 * screenCardSize.y));

                if (pileParent.PileMode == 2/* PileView.Layout.FanRight */) {
                    var deltaX = 1 / scaleX * (topCenterGlobal.x - thisCenterGlobal.x);
                    retval.x = deltaX / this.width;
                } else if (pileParent.PileMode == 1 /*PileView.Layout.FanDown */) {
                    var deltaY = 1 / scaleY * (topCenterGlobal.y - thisCenterGlobal.y);
                    retval.y = deltaY / this._cachedHeight;
                }
            }

            if (retval.x == previousScale.x && retval.y == previousScale.y)
                this._shadowScaleClean = true;
            return retval;
        };

        CardView.prototype.ApplyCardFlipRotation = function (angle) {
            if (angle > Math.PI / 2.0) {
                angle -= Math.PI;
            }

            this._fakeRotationY = angle;
        };

        Object.defineProperty(CardView.prototype, "Highlighted", {
            get: function () {
                return this._highlighted;
            },
            set: function (value) {
                this._highlighted = value;
                this.HighlightTextureVisibility = value;
                this.OnHighlightedChanged();
            }
        });


        CardView.prototype.OnHighlightedChanged = function () {

        };

        CardView.prototype.GetCardPositionInPile = function (pileParent, truePositionOnly) {
            truePositionOnly = !!truePositionOnly;

            if (pileParent == null)
                pileParent = this.parent;

            var position = new PIXI.Point(0, 0);

            var cardBelow = this.GetCardBelow();
            if (cardBelow == null) {
                position.x = 0;
                position.y = 0;
            } else {
                var pileBelow = cardBelow.parent;

                var cardBelowPosition;
                if (cardBelow.IsDragging && !truePositionOnly) {
                    cardBelowPosition = new PIXI.Point(cardBelow.x, cardBelow.y);
                } else {
                    cardBelowPosition = cardBelow.GetCardPositionInPile(pileBelow, truePositionOnly);
                }

                var posFromEnd = this.Card.Pile.GetCardPosFromEnd(this.Card);
                if (pileParent != null && ((pileParent.NumFanning == 0 ||
                    posFromEnd < pileParent.NumFanning) &&
                    ((pileParent.FanFraction <= 1) || (posFromEnd % pileParent.FanFraction == 0)))) {
                    if (pileBelow != null) {
                        var pileSpacing = pileBelow.BlockedPileSpacing;

                        if (typeof pileSpacing == 'undefined') {
                            return position;
                        }
                        position.x = cardBelowPosition.x + pileBelow.x - this.parent.x
                            + (pileSpacing.x * this.CardFront.sprite.texture.width * this.scale.x);
                        position.y = cardBelowPosition.y + pileBelow.y - this.parent.y
                            + (pileSpacing.y * this.CardFront.sprite.texture.width * this.scale.y);
                    }
                    if (cardBelow.IsRevealToShow && this.Card.Pile.IsPileAllowToRevealCard()) {
                        if (this.SupplyView.CurrentLayout != 1)
                            position.y += 30;
                        else
                            position.x += 30;
                    }
                } else {
                    if (pileBelow != null) {
                        position.x = cardBelowPosition.x + pileBelow.x - this.parent.x;
                    }
                }
            }
            return position;
        };

        CardView.prototype.IsInAnimatingStack = function () {
            if (this.Animating)
                return true;

            var cardBelow = this.GetCardBelow();
            if (cardBelow != null)
                return cardBelow.IsInAnimatingStack();

            return false;
        };

        CardView.prototype.IsInAnimatingPile = function () {
            var PileView = require('CardUI/PileView');

            if (this.Animating)
                return true;

            _.forEach(this.parent.children, function (child) {
                if (child instanceof CardView && child.Animating)
                    return true;
            });

            if (this.parent instanceof PileView) {
                var stackedPile = this.parent.StackedPile;
                if (stackedPile != null) {
                    _.forEach(stackedPile.children, function (child) {
                        if (child instanceof CardView && child.Animating)
                            return true;
                    });
                }
            }

            return false;
        };

        /// <summary>
        /// Is this card in the same stack (at or above) as an highlighted card?
        /// </summary>
        /// <returns></returns>
        CardView.prototype.IsInHighlightedStack = function () {
            if (this.SupplyView.GameInputInterpreter.GetHighlightedCard() == this)
                return true;
            
            return false;
        };

        /// <summary>
        /// Sets the IsPickedUp property all cards at or above this card.
        /// </summary>
        /// <param name="isPickedUp"></param>
        CardView.prototype.SetIsPickedUpForCardsAbove = function (isPickedUp) {
            for (var i = this.parent.children.indexOf(this); i < this.parent.children.length; i++) {
                var child = this.parent.children[i];

                if (child == null)
                    continue;

                child.IsPickedUp = isPickedUp;
            }
        };

        /// <summary>
        /// Sets the Layer property all cards at or above this card, incrementing by one per card.
        /// </summary>
        CardView.prototype.SetLayerForCardsAbove = function (startingLayer) {
            var layer = startingLayer;

            for (var i = this.parent.children.indexOf(this); i < this.parent.children.length; i++) {
                var child = this.parent.children[i];

                if (child == null)
                    continue;

                child.Layer = layer;

                layer++;
            }
        };

        CardView.prototype.SetCardFacing = function (facing) {
            this.visible = true;

            var PileView = require('CardUI/PileView');

            if (facing == PileView.Facing.FaceDown) {
                this.CardFlipAngle = 1;
            } else if (facing == PileView.Facing.FaceUp) {
                this.CardFlipAngle = 0;
            } else if (facing == PileView.Facing.Hidden) {
                this.visible = false;
            }
        };

        CardView.prototype.UpdateInteractionMode = function () {
            //var PileView = require('CardUI/PileView');

            var pileParent = this.parent;

            if (pileParent == null)
                return;

            switch (pileParent.InteractionMode) {
                case 0: //case PileView.Interaction.None:
                    this.CardFront.InputEnabled = this.InputEnabled = this.IsDraggable = false;
                    if (this.CardBack != null)
                        this.CardBack.InputEnabled = false;
                    break;

                case 1: //case PileView.Interaction.Click:
                    this.InputEnabled = true;
                    this.CardFront.InputEnabled = false;
                    if (this.CardBack != null)
                        this.CardBack.InputEnabled = false;
                    this.IsDraggable = false;
                    break;

                case 2://case PileView.Interaction.Drag:
                    var canPickup = this.SupplyView.CardSupply.Authority.CanPickupCard(this.Card);
                    this.CardFront.InputEnabled = true;
                    if (this.CardBack != null)
                        this.CardBack.InputEnabled = canPickup;
                    if (canPickup) this.InputEnabled = true;
                    this.IsDraggable = canPickup;
                    break;
            }
        };

        CardView.prototype.Highlight = function () {
            this.Highlighted = true;
        };

        CardView.prototype.ClearHighlight = function () {
            this.Highlighted = false;
        };

        CardView.prototype.GetCardFlipAngle = function (tweenable, propertyType) {
            //value = CardFlipAngle;
            return this.CardFlipAngle;
        };

        CardView.prototype.SetCardFlipAngle = function (tweenable, propertyType, value) {
            this.CardFlipAngle = value;
            this._shadowScaleClean = true;
        };

        CardView.prototype.SetShadowFlipAngle = function (tweenable, propertyType, value) {
            this.shadowFlipAngle = value;
            this._shadowScaleClean = false;
        };

        /// <summary>Get a reference to the CardView before this one, or null if this is the bottommost card (unless piles are stacked)</summary>
        CardView.prototype.GetCardBelow = function () {
            var card = this;

            // We will go through
            var pile = this.parent;
            if (pile == null) {
                return null;
            }

            if (this._cardBelow.Pile == pile) {
                return this._cardBelow.Card;
            }

            var children = pile.children;
            var foundAt = -1;
            while (children != null) {
                if (foundAt < 0) {
                    for (var i = 0; i < children.length; i++) {
                        if (children[i] == card) {
                            foundAt = i;
                            break;
                        }
                    }
                }

                if (foundAt > 0) {
                    for (var j = foundAt - 1; j >= 0; j--) {
                        if (children[j] instanceof CardView) {
                            var child = children[j];
                            this._cardBelow.Card = child;
                            this._cardBelow.Pile = pile;
                            return (child);
                        }
                    }
                }
                if (foundAt >= 0 && pile.StackedPile != null) {
                    pile = pile.StackedPile;
                    children = pile.children;
                    foundAt = pile.children.length;
                } else {
                    break;
                }
            }

            this._cardBelow.Card = null;
            this._cardBelow.Pile = pile;
            return null; // No card is "below" this one, even in stacked piles.
        };

        return CardView;

    });

